
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { NTBService, NTBArticle } from '@/services/news/ntbService';

export const useNTBNews = (limit = 5) => {
  const { i18n } = useTranslation();
  
  return useQuery({
    queryKey: ['ntb-news', limit, i18n.language],
    queryFn: () => NTBService.fetchArticles(limit),
    staleTime: 30 * 60 * 1000, // 30 minutes - longer cache
    gcTime: 60 * 60 * 1000, // 1 hour in memory
    refetchInterval: 30 * 60 * 1000, // Refetch every 30 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export const useNTBArticle = (articleId: string, options?: { enabled?: boolean; searchDate?: string }) => {
  const { i18n } = useTranslation();
  
  return useQuery({
    queryKey: ['ntb-article', articleId, options?.searchDate, i18n.language],
    queryFn: () => NTBService.getArticleById(articleId, options?.searchDate),
    enabled: options?.enabled !== undefined ? options.enabled : !!articleId,
    staleTime: 60 * 60 * 1000, // 1 hour - long cache for individual articles
    gcTime: 2 * 60 * 60 * 1000, // 2 hours in memory
    retry: 2, // Fewer retries for individual articles
    retryDelay: 1000,
  });
};
